'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, $scope, Upload, toaster) {
    this.$http = $http;
    this.$state = $state;
    this.$scope = $scope;
    this.Upload = Upload;
    this.toaster = toaster;

    this.newApp = {
      platform: 'onyx',
      channel: 'onyx',
      type: 'release',
      betaGroups: []
    };
  }

  $onInit() {
    this.$scope.$watch('appsAddCtrl.file', (file) => {
      if (file !== undefined && file !== null) {
        this.uploadApk(file);
      }
    });

    this.getBetaGroups();
  }

  uploadApk(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传APK，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: '/api/apps/uploadFile',
      file: file,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.newApp = Object.assign(this.newApp, data);
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

  update() {
    if (!this.newApp._id) {
      return;
    }
    this.newApp.type = this.newApp.type.toLowerCase();
    this.newApp.channel = this.newApp.channel.toLowerCase();
    this.newApp.platform = this.newApp.platform.toLowerCase();
    this.newApp.deviceMAC = this.newApp.deviceMAC.map(mac => {
      return mac.toLowerCase();
    });

    if (!this.checkData()) {
      return;
    }
    this.$http.put(`/api/apps/${this.newApp._id}`, this.newApp)
      .then(res => {
        this.$state.go('apps');
      });
  }

  getBetaGroups() {
    this.$http.get('/api/betaGroups').then(res => {
      this.betaGroups = res.data;
    });
  }

  toggleSelection(id) {
    let idx = this.newApp.betaGroups.indexOf(id);

    if (idx > -1) {
      this.newApp.betaGroups.splice(idx, 1);
    } else {
      this.newApp.betaGroups.push(id);
    }
  }

  checkStr(str) {
    if (str) {
      str = str.trim();
    }
    return str;
  }

  checkArr(arr) {
    let res = false;
    arr.forEach(item => {
      if (item.trim().length > 0) {
        res = true;
      }
    });
    return res;
  }

  checkData() {
    if (this.checkStr(this.newApp.packageName) && this.checkStr(this.newApp.type)
      && this.checkStr(this.newApp.channel) && this.newApp.versionCode && this.checkStr(this.newApp.platform)
      && this.checkArr(this.newApp.changeLogs.zh_CN)) {
      return true;
    }

    this.toaster.pop({
      type: 'error',
      title: '请填写必填项',
      timeout: 3 * 1000
    });
    return false;
  }
}



// WEBPACK FOOTER //
// ./client/app/apps/add/add.controller.js